import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const BreadcrumbDesktop = styled.nav`
  max-width: var(--pc-width);
  margin: 0 auto;
  background-color: #fff;
  padding: 20px 0;
  position: relative;
  z-index: 15;

  .list {
    ${mixin.flex({ display: 'inline-flex', justify: 'flex-start' })}
    gap:8px;

    .item {
      ${mixin.flex({})}
      position: relative;

      &:last-child > .btn {
        color: #000;
        font-weight: 600;
      }

      &:first-child .icon {
        display: none;
      }

      .btn {
        ${mixin.flex({ justify: 'flex-start' })};
        font-size: 16px;
        line-height: 130%;
        color: #999;
      }

      .icon {
        ${mixin.flex({ display: 'inline-flex' })}
        width: 16px;
        height: 16px;
        margin-right: 8px;

        svg {
          width: 9px;
          height: 14px;
        }
      }

      .icon-cate {
        ${mixin.flex({ display: 'inline-flex' })}
        margin-left: 5px;
      }
    }
  }

  .list-menu-dropdown {
    display: none;
    position: absolute;
    top: 23px;
    left: 24px;
    background-color: #fff;
    border: 1px solid #555;
    padding: 12px;
    box-shadow: 4px 4px 10px 0px rgba(0, 0, 0, 0.04);
    min-width: 180px;

    .item-dropdown {
      ${mixin.flex({ justify: 'normal' })}
      margin-top: 8px;

      &:first-child {
        margin-top: 0;
      }

      .btn {
        width: 100%;
        font-size: 13px;
        line-height: 18px;

        span {
          ${mixin.ellipsis(1)};
          text-align: left;
        }

        &:hover,
        &.active {
          color: #000;
        }
      }
    }

    &::before {
      content: '';
      display: block;
      width: 100%;
      height: 10px;
      position: absolute;
      top: -10px;
      left: 0;
      background-color: transparent;
    }
  }

  .list .item.is-open {
    .list-menu-dropdown {
      display: block;
    }

    .icon-cate {
      transform: rotate(180deg);
    }
  }
`;
